var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt__2", attrs: { id: "interactive-chart" } },
    [
      _c("Menu", {
        ref: "menu",
        attrs: { selected: _vm.selected },
        on: {
          select: _vm.select,
          deselect: _vm.deselect,
          "select-all": _vm.selectAll,
          "deselect-all": _vm.deselectAll,
        },
      }),
      _vm._v(" "),
      _c("Chart", { ref: "chart", attrs: { selected: _vm.selected } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }